/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cotizador = __webpack_require__(3);
	
	var _cotizador2 = _interopRequireDefault(_cotizador);
	
	var _hotelListItem = __webpack_require__(6);
	
	var _hotelListItem2 = _interopRequireDefault(_hotelListItem);
	
	var _tab = __webpack_require__(9);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _hoverable = __webpack_require__(15);
	
	var _hoverable2 = _interopRequireDefault(_hoverable);
	
	var _imgSlider = __webpack_require__(18);
	
	var _imgSlider2 = _interopRequireDefault(_imgSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ComponentsModule = _angular2.default.module('mvac.components', [_cotizador2.default, _hotelListItem2.default, _tab2.default, _hoverable2.default, _imgSlider2.default]).name;
	
	exports.default = ComponentsModule;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = angular;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _cotizador = __webpack_require__(4);
	
	var _cotizador2 = _interopRequireDefault(_cotizador);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CotizadorModule = _angular2.default.module('mvac.cotizador', []).component('cotizador', _cotizador2.default).name;
	
	exports.default = CotizadorModule;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _cotizador = __webpack_require__(5);
	
	var _cotizador2 = _interopRequireDefault(_cotizador);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CotizadorComponent = {
		controller: _cotizador2.default,
		controllerAs: 'cotizador',
		bindings: {
			initializationData: '<',
			step: '<',
			initialStay: '<',
			onSubmit: '&',
			display: '@',
			modulo: '@',
			colores: '@',
			fondo: '@',
			editDestination: '@',
			typeblock: '@',
			cotizadorSeleccionado: '@'
		},
		templateUrl: '/components/cotizador'
	};
	
	exports.default = CotizadorComponent;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CotizadorController = function () {
	    function CotizadorController(variablesService, DatosCotizador, HotelFactory, $scope) {
	        _classCallCheck(this, CotizadorController);
	
	        this.datosCotizador = DatosCotizador;
	        this.variablesService = variablesService;
	        this.HotelFactory = HotelFactory;
	        this.$scope = $scope;
	        this.stay = {};
	        this.destination = {};
	        this.adultsAmount = 2;
	        this.childrenAmount = 0;
	        this.roomsInfo = [{
	            nHabitacion: 1,
	            adults: 2,
	            children: 0,
	            edadNinios: []
	        }];
	        this.selectParams = {
	            room: {
	                options: [1, 2, 3, 4, 5],
	                value: 1
	            },
	            adults: {
	                options: [1, 2, 3, 4, 5]
	            },
	            children: {
	                options: [0, 1, 2, 3, 4, 5]
	            },
	            childrenAge: {
	                options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
	            },
	            itemsPage: {
	                options: [10, 20, 30]
	            }
	        };
	        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
	        if (this.isMobile) {
	            $('.selectpicker').selectpicker('mobile');
	        }
	
	        this.cotizador();
	    }
	
	    _createClass(CotizadorController, [{
	        key: 'cotizador',
	        value: function cotizador() {
	            var numAdult = 0;
	            var numChildren = 0;
	            var data = this;
	            if (window.location.pathname != '/') {
	                data = this.HotelFactory.getCotizador();
	                angular.forEach(data.occupancies, function (hb) {
	                    numAdult += hb.adults * hb.rooms;
	                    numChildren += hb.children * hb.rooms;
	                });
	                if (numAdult != 0) {
	                    data.adultsAmount = numAdult;
	                } else {
	                    data.adultsAmount = 2;
	                }
	                if (numChildren != 0) {
	                    data.childrenAmount = numChildren;
	                } else {
	                    data.childrenAmount = 0;
	                }
	            }
	        }
	    }, {
	        key: 'propiedadesinline',
	        value: function propiedadesinline() {
	            this.colsdestino = 'col-md-4 bri';
	            this.colDates = 'col-md-3 bri';
	            this.colHab = 'col-md-3 bri';
	            this.colHabDet = 'col-md-2';
	            this.colHabDetAdult = 'col-md-2';
	            this.colHabDetNinios = 'col-md-2';
	            this.colBtn = 'col-md-2';
	            this.advance = 'book_habs';
	            this.avanzado = '';
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            this.columns = 'row';
	            this.rows = '';
	            this.posicioncotprin = '';
	            this.posicioncot = 'row';
	            this.marginform = '';
	            this.padcotizador = '';
	            this.lbentrada = 'Llegada';
	            this.lbsalida = 'Salida';
	            this.rowEdades = 'col-md-12';
	            this.etiquetaslb = 'lbindexcot mb-0';
	            this.etiquetaslbhab = 'lbindexcothab';
	            this.colEdadesNinios = 'col-md-6';
	            this.classGroupHab = '';
	            this.btnMargin = 'mt25';
	            this.colNumPicker = '6';
	            this.btnSizeClass = this.display == 'inline' ? '' : 'btn-lg';
	
	            this.classGroup = this.display == 'inline' ? '' : 'input-group';
	            this.btnTypeClass = this.display == 'inline' ? 'primary' : 'danger';
	            this.menuAdvance = this.display == 'inline' ? false : true;
	            this.editableDestination = typeof this.editDestination === 'undefined';
	            this.avanzado = 'none';
	            this.menuavanzado = 'col-md-12';
	            this.rowavanzado = 'row';
	            this.hidemt = '';
	            this.hide = '';
	            this.rowdetalleshab = 'col-md-12';
	            this.rowadvanced = '';
	            this.hidepadd = '';
	            this.showfechas = this.modulo == 'detalles' ? 'true' : 'false';
	            this.detallesavanzado = '';
	            this.hidemargin = '';
	            this.margint1 = '';
	            this.deletepadd = '';
	            this.lblHab = 'col-md-2';
	            this.coldefaultHab = '';
	            this.checkAddAuto = 'col-xs-12 col-sm-12 col-md-12';
	            this.tipoCotizador = this.cotizadorSeleccionado;
	            this.destinations = [];
	            if (this.tipoCotizador == 1) {
	                var destinations = this;
	                this.HotelFactory.getMxDestinations().then(function (response) {
	                    destinations.destinations = response.data;
	                });
	            }
	            switch (this.modulo) {
	
	                case 'inicio':
	                    if (this.display == "inline") {
	                        // COTIZADOR DEL INDEX DE OUTLET
	                        this.propiedadesinline();
	                    } else if (this.display == 'block' && this.typeblock == 'list') {
	                        // COTIZADOR DEL INDEX EN LISTA DE HOTELES
	                        this.colsdestino = 'col-md-12';
	                        this.colDates = 'col-md-12 mt15';
	                        this.colHab = 'col-md-3 col-xs-12 mt15';
	                        this.colHabDet = 'col-md-4 col-xs-6 mt15';
	                        this.colHabDetAdult = 'col-md-3';
	                        this.colHabDetNinios = 'col-md-3';
	                        this.colBtn = 'col-xs-12 col-sm-6 col-md-6 pl-xs-2 pl-sm-2 pl-md-0 pl-lg-2';
	                        this.colEdadesNinios = 'col-md-12 col-xs-12 mt15';
	                        this.classGroupHab = 'input-group col-md-12 col-xs-12';
	                        this.busqueda = 'col-md-12 col-xs-12';
	                        this.rowEdades = 'col-md-8';
	                        this.lbentrada = 'Llegada:';
	                        this.lbsalida = 'Salida:';
	                        this.padcotizador = 'padindexcot pr-lg-0 pr-md-2 pr-xs-2 pr-sm-2';
	                        this.marginform = 'margincot';
	                        this.rowhabitaciones = 'margin-left: 15px;';
	                        this.detselect = 'slate';
	                        this.lblHab = 'col-md-3';
	                        this.etiquetaslbhab = 'lbindexcothab';
	                        this.coldefaultHab = 'col-md-12';
	                    } else {
	                        //  COTIZADOR DEL INDEX
	                        //se asginan margin de 15px cuando es block para espaciar las columnas
	                        this.colsdestino = 'col-md-12';
	                        this.colDates = 'col-md-12 mt15';
	                        this.colHab = 'col-md-4 col-xs-12 mt15';
	                        this.colHabDet = 'col-md-5 col-xs-6 mt15';
	                        this.colHabDetAdult = 'col-md-3';
	                        this.colHabDetNinios = 'col-md-3';
	                        this.colBtn = 'col-xs-12 col-sm-6 col-md-6 pl-xs-2 pl-sm-2 pl-md-0 pl-lg-0';
	                        this.colEdadesNinios = 'col-md-12 col-xs-12 mt15';
	                        this.classGroupHab = 'input-group col-md-12 col-xs-12';
	                        this.busqueda = 'col-md-12 col-xs-12';
	                        this.rowEdades = 'col-md-7';
	                        this.lbentrada = 'Llegada:';
	                        this.lbsalida = 'Salida:';
	                        this.padcotizador = 'padindexcot';
	                        this.marginform = 'margincot';
	                        this.rowhabitaciones = 'margin-left: 15px;';
	                        this.detselect = 'slate';
	                        this.checkAddAuto = 'col-xs-12 col-sm-6 col-md-6';
	                    }
	                    break;
	
	                case 'lista-hoteles':
	                    if (this.display == "inline") {
	                        // COTIZAD DE OUTLET EN LISTA DE HOTELES
	                        this.propiedadesinline();
	                    } else {
	                        // COTIZADOR DE LISTA DE HOTLES EN MVAC TIPO BLOCK
	                        //marginbottom para espacio ente destino y fechas
	                        this.colsdestino = 'col-md-12 mb5';
	                        this.colDates = 'col-md-12';
	                        this.colHab = 'col-md-12';
	                        this.colHabDet = 'col-md-6';
	                        this.colHabDetAdult = 'col-md-6';
	                        this.colHabDetNinios = 'col-md-6';
	                        this.colBtn = 'col-md-12';
	                        this.btnSizeClass = '';
	                        this.colNumPicker = '12';
	                        //VALORES PARA ADECUAR COLUMNA HABITACIONES
	                        this.colHabAdultNinios = 'wrap-habts';
	                        this.colEdadesNinios = 'col-md-12';
	                        //AJUSTA ANCHO Y PADDING DEL COTIZADOR
	                        this.background = 'blue br11';
	                        this.btnMargin = 'mt15';
	                        this.buscadorblue = 'buscadorblue';
	                        this.etiquetaslb = 'lblistacot';
	                        this.etiquetaslbhab = 'lblistacothab';
	                    }
	
	                    break;
	                case 'detalles':
	                    if (this.display == 'inline') {
	                        // COTIZADOR DE MVAC TIPO INLINE EN DETALLLES
	                        this.showdestino = 'display:none;';
	                        //this.colsdestino    = 'col-md-4 bri mb5';
	                        this.colDates = 'col-md-5 bri fondoContPicker';
	                        this.colHab = 'col-md-6 bri';
	                        this.colHabDet = 'col-md-2';
	                        this.colHabDetAdult = 'col-md-2';
	                        this.colHabDetNinios = 'col-md-2';
	                        this.colBtn = 'col-md-1';
	                        this.advance = 'book_habs';
	                        this.avanzado = '';
	                        this.posicioncot = 'row';
	                        this.posicioncotprin = 'col-md-12';
	                        this.menuavanzado = 'row'; //pendiente
	                        this.rowavanzado = 'col-md-12';
	                        this.hidemt = 'hidemt10';
	                        this.hide = 'hidebtncot';
	                        this.rowEdades = '';
	                        this.rowdetalleshab = '';
	                        this.rows = 'row';
	                        this.columns = 'col-md-12';
	                        this.rowadvanced = 'rowadvanced';
	                        this.hidepadd = 'delpadd mr10';
	                        this.deletepadd = 'delpadd';
	                        this.detallesavanzado = 'contmenuadvanced';
	                        this.hidemargin = 'hidemargin';
	                        this.margint1 = 'mb1';
	                    }
	                    break;
	                default:
	                    // COTIZADOR DE OUTLET EN DETALLES
	                    this.propiedadesinline();
	                    break;
	            }
	
	            $('#destinations').on('shown.bs.modal', function () {
	                $('.sticky-top').css('position', 'initial');
	            });
	            $('#destinations').on('hidden.bs.modal', function () {
	                $('.sticky-top').css('position', 'sticky');
	            });
	
	            $('.dp').on('click', function (event) {
	                event.stopPropagation();
	            });
	
	            $(".btn-close-dropdown").click(function () {
	                $("#room_peoples").removeClass("show");
	            });
	
	            $(".dp").css("width", $("#dropdownHuespedes")[0].offsetWidth !== 0 ? $("#dropdownHuespedes")[0].offsetWidth : '100%');
	
	            $('.destinationAutocomplete').bind('typeahead:callback.onClick', function (ev, data) {
	                var selectedCity = localStorage.getItem('selectedCity');
	                selectedCity = JSON.parse(selectedCity);
	                var params = {};
	                if (selectedCity.type == 'Destination') {
	                    selectedCity.name = selectedCity.name.replace('(and vicinity)', '');
	                    params = {
	                        destinationCode: selectedCity.code,
	                        name: selectedCity.name
	                    };
	                    _this.type = 'Destiny';
	                    _this.id = selectedCity.code;
	                }
	                if (selectedCity.type == 'Zone') {
	                    params = {
	                        destinationCode: selectedCity.code,
	                        name: selectedCity.name,
	                        zone: selectedCity.zone_code
	                    };
	                    _this.type = 'Zone';
	                    _this.id = selectedCity.zone_code;
	                }
	                if (selectedCity.type == 'Hotel') {
	                    params = {
	                        destinationCode: selectedCity.city_code,
	                        name: selectedCity.name,
	                        hotelCode: selectedCity.hotel_code,
	                        token: ''
	                    };
	                    _this.type = 'Hotel';
	                    _this.id = selectedCity.hotel_code;
	                }
	                _this.destination = params;
	                _this.destination.completeName = selectedCity.name;
	                localStorage.setItem('cotizadorSeleccionado', 2);
	            });
	            // }
	
	            // $('.destinationAutocomplete').bind('typeahead:select', (ev, data) => {
	            //     console.log(data, "data");
	            //     // console.log(ev, "ev");
	            //     // console.log('test');
	            //     var params = {};
	            //     if(data.searchType == 'destination'){
	            //         data.name = data.name.replace('(and vicinity)', '');
	            //         params = {
	            //             destinationCode : data.destinationCode,
	            //             name : data.name
	            //         }
	            //         this.type  = 'Destiny';
	            //         this.id    = data.id;
	            //     }
	            //     if(data.searchType == 'zone'){
	            //         params = {
	            //             destinationCode : data.destinationCode,
	            //             name    : data.name,
	            //             zone    : data.code 
	            //         }
	            //         this.type   = 'Zone';
	            //         this.id     = data.id;
	            //     }
	            //     if(data.searchType == 'hotel'){
	            //         params = {
	            //             destinationCode : data.destinationCode,
	            //             name        : data.name,
	            //             hotelCode   : data.code,
	            //             token       : data.tokenName
	            //         }
	            //         this.type       = 'Hotel';
	            //         this.id         = data.id;
	            //     }
	            //     this.destination = params;
	            //     this.destination.completeName = data.completeName;
	            //     localStorage.setItem('cotizadorSeleccionado', 2);
	            // });
	            $('.hidden-element').addClass('visible-element');
	        }
	    }, {
	        key: '$postLink',
	        value: function $postLink() {
	            if (localStorage.getItem('fillQuotationForm') === 'true') {
	                this.fillQuotationForm();
	            }
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	
	            if (changes.initializationData) {
	                if (!angular.equals(changes.initializationData.currentValue, {}) && typeof changes.initializationData.currentValue !== 'undefined') {
	                    this.initializationData = angular.copy(this.initializationData);
	                    this.makeCotizador();
	                }
	            }
	        }
	    }, {
	        key: 'setDestination',
	        value: function setDestination(destinationCode, destinationName) {
	            var _this2 = this;
	
	            angular.forEach(this.destinations, function (element, index) {
	                if (destinationCode != "") {
	                    if (element.id_api_destinos == destinationCode) {
	                        var params = {
	                            destinationCode: destinationCode,
	                            name: element.name.replace('(and vicinity)', '')
	                        };
	                        _this2.type = 'Destiny';
	                        _this2.id = element.id;
	                        _this2.destination = params;
	                        _this2.destination.completeName = element.name.replace('(and vicinity)', '');
	                        _this2.destination.name = element.name;
	                        _this2.destino = element.name;
	                        _this2.id_api_destinos = destinationCode;
	                        if (!angular.equals(_this2.initializationData, {})) {
	                            _this2.initializationData.destination.name = element.name;
	                        }
	                        $('.selectpicker').selectpicker('val', element.name);
	                        $('#destinations').modal('hide');
	                    }
	                }
	
	                if (destinationName != "") {
	                    if (element.name == destinationName) {
	                        var _params = {
	                            destinationCode: element.id_api_destinos,
	                            name: element.name.replace('(and vicinity)', '')
	                        };
	                        _this2.type = 'Destiny';
	                        _this2.id = element.id;
	                        _this2.destination = _params;
	                        _this2.destination.name = element.name;
	                        _this2.destination.completeName = element.name.replace('(and vicinity)', '');
	                        _this2.destino = element.name;
	                        _this2.id_api_destinos = element.id_api_destinos;
	                        $('.selectpicker').selectpicker('val', element.name);
	                        $('#destinations').modal('hide');
	                    }
	                }
	            });
	            localStorage.setItem('cotizadorSeleccionado', 1);
	        }
	    }, {
	        key: 'makeCotizador',
	        value: function makeCotizador() {
	            var _this3 = this;
	
	            angular.forEach(this.initializationData.occupancies, function (occupancy, index) {
	
	                for (var _i = 0; _i < occupancy.rooms; _i++) {
	                    if (_i == 0 && index == 0) {
	                        _this3.roomsInfo[0].adults = occupancy.adults;
	                        _this3.roomsInfo[0].children = occupancy.children;
	                        _this3.roomsInfo[0].edadNinios = occupancy.paxes;
	                    } else {
	                        _this3.roomsInfo.push({
	                            nHabitacion: _i + 1,
	                            adults: angular.copy(occupancy.adults),
	                            children: angular.copy(occupancy.children),
	                            edadNinios: angular.copy(occupancy.paxes)
	                        });
	                        _this3.selectParams.room.value += 1;
	                    }
	                }
	            });
	
	            this.destination = this.initializationData.destination;
	            this.stay.checkIn = this.initializationData.stay.checkIn;
	            this.stay.checkOut = this.initializationData.stay.checkOut;
	            this.id = this.initializationData.token;
	            this.type = this.initializationData.type;
	            this.destino = this.destination.name;
	            // new code 
	            this.initialStay.checkIn = this.initializationData.stay.checkIn;
	            this.initialStay.checkOut = this.initializationData.stay.checkOut;
	            this.totalNoches = moment(this.initializationData.stay.checkOut, 'YYYY-MM-DD').diff(moment(this.initializationData.stay.checkIn, 'YYYY-MM-DD'), 'days');
	
	            if (this.initializationData.destination.hasOwnProperty('name')) {
	                $('.destinationAutocomplete ').typeahead('val', this.initializationData.destination.name);
	            }
	
	            if (this.cotizadorSeleccionado == 1) {
	                this.setDestination('', this.destination.name);
	            }
	
	            this.calculateOccupancyAmount();
	        }
	    }, {
	        key: 'press',
	        value: function press(isValid) {
	            localStorage.setItem('cotizadorSeleccionado', this.tipoCotizador);
	            localStorage.removeItem('hotelSelected');
	            if (window.location.pathname == "/hotelv2") {
	                localStorage.setItem('page', 'detalles');
	            } else {
	                localStorage.setItem('page', 'inicio');
	            }
	            if (angular.equals(this.destination, {})) isValid = false;
	
	            this.datosCotizador.reset();
	            this.buildData(this.step);
	
	            this.onSubmit({
	                $event: {
	                    isValid: isValid,
	                    step: this.step
	                }
	            });
	        }
	    }, {
	        key: 'buildData',
	        value: function buildData() {
	            var _this4 = this;
	
	            var checkIn = "";
	            var checkOut = "";
	
	            if ($('#checkInFieldHotel').length > 0 && $('#checkOutFieldHotel').length > 0) {
	                checkIn = $('#checkInFieldHotel').val();
	                checkOut = $('#checkOutFieldHotel').val();
	            }
	            if ($('#checkInTwoStep').length > 0 && $('#checkOutTwoStep').length > 0) {
	                checkIn = $('#checkInTwoStep').val();
	                checkOut = $('#checkOutTwoStep').val();
	            }
	            if ($('#checkIn').length > 0 && $('#checkOut').length > 0) {
	                checkIn = $('#checkIn').val();
	                checkOut = $('#checkOut').val();
	            }
	            this.stay.shiftDays = 2;
	            this.stay.checkIn = checkIn.length > 0 ? checkIn : $('#checkInTwoStep').val();
	            this.stay.checkOut = checkOut.length > 0 ? checkOut : $('#checkOutTwoStep').val();
	            this.stay.totalNights = moment(this.stay.checkOut, 'YYYY-MM-DD').diff(moment(this.stay.checkIn, 'YYYY-MM-DD'), 'days');
	            if (localStorage.getItem("cotizadorSeleccionado") === null) {
	                localStorage.setItem('cotizadorSeleccionado', 1);
	                console.log(localStorage.getItem('cotizadorSeleccionado'));
	            }
	            this.stay.cotizadorSeleccionado = localStorage.getItem('cotizadorSeleccionado');
	
	            angular.forEach(this.roomsInfo, function (value, key) {
	                if (_this4.datosCotizador.occupancies.length > 0) {
	                    var coincidencia = false;
	                    for (var i = 0; i < _this4.datosCotizador.occupancies.length; i++) {
	                        if (_this4.datosCotizador.occupancies[i].adults == value.adults && _this4.datosCotizador.occupancies[i].children == value.children) {
	                            var sameAges = true;
	                            if (value.children > 0) {
	                                var clEdadesValue = value.edadNinios.slice();
	                                var _continue = true;
	                                while (clEdadesValue.length > 0 && _continue) {
	                                    var _age = clEdadesValue.splice(0, 1)[0].age;
	                                    var ageFinded = false;
	                                    for (var _i = 0; _i < _this4.datosCotizador.occupancies[i].paxes.length; _i++) {
	                                        if (_age == _this4.datosCotizador.occupancies[i].paxes[_i].age) {
	                                            ageFinded = true;
	                                            break;
	                                        }
	                                    }
	                                    if (!ageFinded) {
	                                        _continue = false;
	                                        sameAges = false;
	                                    }
	                                }
	                            }
	                            if (sameAges) {
	                                _this4.datosCotizador.occupancies[i].rooms += 1;
	                                coincidencia = true;
	                            }
	                        }
	                    }
	                    if (!coincidencia) {
	                        _this4.datosCotizador.occupancies.push({
	                            rooms: 1,
	                            adults: value.adults,
	                            children: value.children,
	                            paxes: []
	                        });
	                        if (value.children > 0) {
	                            for (var i = 0; i < value.children; i++) {
	                                _this4.datosCotizador.occupancies[_this4.datosCotizador.occupancies.length - 1].paxes.push({
	                                    type: 'CH',
	                                    age: value.edadNinios[i].age
	                                });
	                            }
	                        }
	                    }
	                } else {
	                    _this4.datosCotizador.occupancies.push({
	                        rooms: 1,
	                        adults: value.adults,
	                        children: value.children,
	                        paxes: []
	                    });
	                    if (value.children > 0) {
	                        for (var i = 0; i < value.children; i++) {
	                            _this4.datosCotizador.occupancies[0].paxes.push({
	                                type: 'CH',
	                                age: value.edadNinios[i].age
	                            });
	                        }
	                    }
	                }
	            });
	
	            this.datosCotizador.stay = this.stay;
	            this.datosCotizador.destination = this.destination;
	            this.datosCotizador.step = this.step;
	            this.datosCotizador.type = this.type;
	            this.datosCotizador.token = this.id;
	            window.location.href = '/hotelv2';
	        }
	    }, {
	        key: 'changeChildAmount',
	        value: function changeChildAmount(hab) {
	            if (hab.edadNinios.length > hab.children) {
	                var diff = hab.edadNinios.length - hab.children;
	                hab.edadNinios.splice(hab.children, diff);
	            } else if (hab.edadNinios.length < hab.children) {
	                for (var i = hab.edadNinios.length; i < hab.children; i++) {
	                    hab.edadNinios[i] = {
	                        "age": 1
	                    };
	                }
	            }
	            this.calculateOccupancyAmount();
	        }
	    }, {
	        key: 'changeNumberRoom',
	        value: function changeNumberRoom() {
	            // console.log(this.selectParams.room.value, "room value");
	            if (this.roomsInfo.length > this.selectParams.room.value) {
	                var diff = this.roomsInfo.length - this.selectParams.room.value;
	                this.roomsInfo.splice(this.selectParams.room.value, diff);
	            } else if (this.roomsInfo.length < this.selectParams.room.value) {
	                for (var i = this.roomsInfo.length; i < this.selectParams.room.value; i++) {
	                    this.roomsInfo.push({
	                        nHabitacion: i + 1,
	                        adults: 2,
	                        children: 0,
	                        edadNinios: []
	                    });
	                }
	            }
	
	            this.calculateOccupancyAmount();
	        }
	    }, {
	        key: 'showMenuAdvance',
	        value: function showMenuAdvance() {
	            this.menuAdvance = !this.menuAdvance;
	            // console.log(this.menuAdvance);
	        }
	    }, {
	        key: 'calculateOccupancyAmount',
	        value: function calculateOccupancyAmount() {
	            var _this5 = this;
	
	            this.adultsAmount = 0;
	            this.childrenAmount = 0;
	            angular.forEach(this.roomsInfo, function (roomInfo) {
	                _this5.adultsAmount += roomInfo.adults;
	                _this5.childrenAmount += roomInfo.children;
	            });
	        }
	    }, {
	        key: 'fillQuotationForm',
	        value: function fillQuotationForm() {
	            var _this6 = this;
	
	            var search = JSON.parse(localStorage.getItem('search'));
	            angular.forEach(search.occupancies, function (occupancy, index) {
	                for (var _i = 0; _i < occupancy.rooms; _i++) {
	                    if (_i == 0 && index == 0) {
	                        _this6.roomsInfo[0].adults = occupancy.adults;
	                        _this6.roomsInfo[0].children = occupancy.children;
	                        _this6.roomsInfo[0].edadNinios = occupancy.paxes;
	                    } else {
	                        _this6.roomsInfo.push({
	                            nHabitacion: _i + 1,
	                            adults: angular.copy(occupancy.adults),
	                            children: angular.copy(occupancy.children),
	                            edadNinios: angular.copy(occupancy.paxes)
	                        });
	                        _this6.selectParams.room.value += 1;
	                    }
	                }
	            });
	            this.datosCotizador.occupancies = search.occupancies;
	            this.datosCotizador.stay = search.stay;
	            this.datosCotizador.step = search.step;
	            this.datosCotizador.destination = search.destination;
	            this.datosCotizador.token = search.token;
	            this.datosCotizador.type = search.type;
	            this.stay = search.stay;
	            this.destination = search.destination;
	            this.type = search.type;
	            this.id = search.token;
	            this.destino = search.destination.name;
	            this.id_api_destinos = search.destination.destinationCode;
	            this.initialStay.checkIn = search.stay.checkIn;
	            this.initialStay.checkOut = search.stay.checkOut;
	            this.calculateOccupancyAmount();
	            localStorage.setItem('fillQuotationForm', 'false');
	        }
	    }]);
	
	    return CotizadorController;
	}();
	
	CotizadorController.$inject = ['variablesService', 'DatosCotizador', 'HotelFactory'];
	
	exports.default = CotizadorController;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _hotelListItem = __webpack_require__(7);
	
	var _hotelListItem2 = _interopRequireDefault(_hotelListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotelListItemModule = _angular2.default.module('mvac.hotelListItem', []).component('hotelListItem', _hotelListItem2.default).name;
	
	exports.default = HotelListItemModule;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _hotelListItem = __webpack_require__(8);
	
	var _hotelListItem2 = _interopRequireDefault(_hotelListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotelItemListComponent = {
	    bindings: {
	        hotel: '<',
	        isDataLoaded: '<',
	        marca: '@',
	        numr: '<'
	    },
	    controller: _hotelListItem2.default,
	    templateUrl: '/components/hotel_item_list'
	};
	
	exports.default = HotelItemListComponent;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HotelListItemController = function () {
	    function HotelListItemController($scope, $window, $log, HotelFactory, ContentApiService, variablesService, CurrencyDictionary) {
	        var _this = this;
	
	        _classCallCheck(this, HotelListItemController);
	
	        this.currencyDictionary = CurrencyDictionary;
	        this.hotelFactory = HotelFactory;
	        this.$scope = $scope;
	
	        this.$window = $window;
	        this.log = $log;
	        this.contentApiService = ContentApiService;
	        this.pathImages = variablesService.pathImages;
	        this.pathImagesMedium = variablesService.pathImagesMedium;
	        this.pathImagesBigger = variablesService.pathImagesBigger;
	
	        this.tabSelected = -1;
	        this.tabs = [false, false, false, false];
	        this.openingTab = false;
	        this.$scope.$watch(function () {
	            return _this.hotel.packageGrouped;
	        }, function (newValue, oldValue) {
	            if (_this.hotel.rates == 1) {}
	        });
	    }
	
	    _createClass(HotelListItemController, [{
	        key: '$onInit',
	        value: function $onInit() {}
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            var _this2 = this;
	
	            angular.forEach(this.hotel.rooms, function (rooms) {
	                var allotment = 0;
	                angular.forEach(rooms.rates, function (rates) {
	                    allotment += rates.allotment;
	                    // if (rates.rateType == 'RECHECK') {
	                    // console.log(this.hotel.name + ' recheck');
	                    // swal('Espera', 'No hay disponibilidad', 'warning');
	                    // return false;
	                    // }
	                });
	                _this2.hotel.allotment = allotment;
	            });
	        }
	    }, {
	        key: 'loadTab',
	        value: function loadTab(index) {
	            var _this3 = this;
	
	            if (index != this.tabSelected) {
	                if (this.tabSelected >= 0) this.tabs[this.tabSelected] = false;
	                this.tabSelected = index;
	            }
	
	            this.tabs[index] = !this.tabs[index];
	
	            if (index == 0 && this.tabs[index]) {
	                this.contentApiService.get([this.hotel.code], ['images']).then(function (response) {
	                    angular.extend(_this3.hotel.content.images, response.data.hotels[0].images);
	                    _this3.imageGroup();
	                });
	            }
	
	            if (index == 1 && this.tabs[index]) {
	                this.contentApiService.get([this.hotel.code], ['interestPoints']).then(function (response) {
	                    if (angular.isDefined(response.data.hotels[0].interestPoints)) {
	                        _this3.hotel.content.interestPoints = [];
	                        angular.extend(_this3.hotel.content.interestPoints, response.data.hotels[0].interestPoints);
	                    }
	                });
	            }
	
	            if (index == 3 && this.tabs[index]) {
	                this.contentApiService.get([this.hotel.code], ['description']).then(function (response) {
	                    if (angular.isDefined(response.data.hotels[0].description)) {
	                        _this3.hotel.content.description = response.data.hotels[0].description;
	                    }
	                });
	            }
	        }
	    }, {
	        key: 'hotelSelected',
	        value: function hotelSelected(clickEvent) {
	            // angular.element(clickEvent.target).append(' <i class="fa fa-spin fa-spinner"></i>');
	            var query = '';
	
	            var hBack = angular.copy(this.hotel);
	            // console.log(hBack, 'datos_hotel');
	
	            if (typeof hBack.packageGrouped !== 'undefined') {
	                var setter = false;
	                angular.forEach(hBack.packageGrouped, function (group) {
	                    angular.forEach(group, function (_package) {
	                        if (!setter) {
	                            query = _package.boardCode;
	                            setter = true;
	                        }
	                    });
	                });
	                delete hBack.packageGrouped;
	            }
	
	            if (this.hotelFactory.isLocalStorageAvailable()) {
	                localStorage.setItem('hotelSelected', JSON.stringify(hBack));
	            }
	            // this.$window.location.href = '/hotel/details/' + this.hotel.tokenName + '?flt=' + query;
	            var target = $('#target').val() == '1' ? '_blank' : '_self';
	            window.open('/hotel/details/' + this.hotel.tokenName + '?flt=' + query, target);
	        }
	    }, {
	        key: 'imageGroup',
	        value: function imageGroup() {
	            var imagenes = [];
	            //  console.log(this.hotel.code,'####################');
	            this.codeHotel = this.hotel.code;
	            if (this.hotel.content.images) {
	                this.hotel.fotoActual = this.hotel.content.images[0].path;
	                var limSup = this.hotel.content.images.length;
	                for (var __i = 0; __i < limSup; __i++) {
	                    imagenes.push(/^\/.+$/.test(this.hotel.content.images[__i].path) ? this.hotel.content.images[__i].path : '/' + this.hotel.content.images[__i].path);
	                }
	                this.imgApihotel = this.hotel.content.images;
	                this.hotel.imagenes = imagenes;
	                Array.prototype.unique = function (a) {
	                    return function () {
	                        return this.filter(a);
	                    };
	                }(function (a, b, c) {
	                    return c.indexOf(a, b + 1) < 0;
	                });
	                this.hotel.imagenes = this.hotel.imagenes.unique();
	            }
	        }
	    }, {
	        key: 'fnIconocurrency',
	        value: function fnIconocurrency(currency) {
	            // console.log(currency, "currency");
	            switch (currency) {
	                case 'USD':
	                    this.hotel.iconocurrency = '$';
	                    break;
	                case 'EUR':
	                    this.hotel.iconocurrency = '€';
	                    break;
	                case 'GBP':
	                    this.hotel.iconocurrency = '£';
	                    break;
	                default:
	                    this.hotel.iconocurrency = '$';
	                    break;
	            }
	
	            // 'USD': '$',
	            // 	'EUR': '€',
	            // 	'GBP': '£',
	            // 	'MXN': '$'
	            // this.hotel.iconocurrency = currencyDictionary[currency];
	        }
	    }]);
	
	    return HotelListItemController;
	}();
	
	HotelListItemController.$inject = ['$scope', '$window', '$log', 'HotelFactory', 'ContentApiService', 'variablesService', 'CurrencyDictionary'];
	
	exports.default = HotelListItemController;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tab = __webpack_require__(10);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _tabPanel = __webpack_require__(12);
	
	var _tabPanel2 = _interopRequireDefault(_tabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabModule = _angular2.default.module('tab', [_tabPanel2.default]).component('tab', _tab2.default).name;
	
	exports.default = TabModule;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tab = __webpack_require__(11);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabComponent = {
	    transclude: true,
	    bindings: {
	        firstByDefault: '@',
	        closeable: '@'
	    },
	    template: '\n        <ul class="nav nav-tabs">\n            <li ng-repeat="tab in $ctrl.tabs">\n                <a href=""\n                    ng-bind="tab.title"\n                    ng-click="$ctrl.selectTab($index);"\n                    ng-class="tab.selected ? \'tab-active\' : \'\'"></a>\n            </li>\n        </ul>\n        <div class="tab-content" ng-transclude>\n        \n        </div> \n    ',
	    controller: _tab2.default
	};
	
	exports.default = TabComponent;

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TabController = function () {
	    function TabController() {
	        _classCallCheck(this, TabController);
	
	        this.tabSelected = -1;
	    }
	
	    _createClass(TabController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.tabs = [];
	            this.setFirst = typeof this.firstByDefault == 'undefined' ? false : true;
	            this.isClosable = typeof this.closeable == 'undefined' ? false : true;
	        }
	    }, {
	        key: 'addTab',
	        value: function addTab(tab) {
	            if (this.tabs.length == 0 && this.setFirst) {
	                tab.selected = true;
	                this.tabSelected = 0;
	            }
	
	            this.tabs.push(tab);
	        }
	    }, {
	        key: 'selectTab',
	        value: function selectTab(index) {
	            if (this.isClosable) {
	                if (index != this.tabSelected) {
	                    if (this.tabSelected >= 0) this.tabs[this.tabSelected].selected = false;
	                    this.tabSelected = index;
	                }
	
	                this.tabs[index].selected = !this.tabs[index].selected;
	            } else {
	                if (index != this.tabSelected) {
	                    if (this.tabSelected >= 0) this.tabs[this.tabSelected].selected = false;
	                    this.tabs[index].selected = true;
	                    this.tabSelected = index;
	                }
	            }
	        }
	    }]);
	
	    return TabController;
	}();
	
	exports.default = TabController;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tabPanel = __webpack_require__(13);
	
	var _tabPanel2 = _interopRequireDefault(_tabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabPanelModule = _angular2.default.module('tab.panel', []).component('tabPanel', _tabPanel2.default).name;
	
	exports.default = TabPanelModule;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tabPanel = __webpack_require__(14);
	
	var _tabPanel2 = _interopRequireDefault(_tabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabPanelComponent = {
	    bindings: {
	        title: '@'
	    },
	    require: {
	        tab: '^^'
	    },
	    transclude: true,
	    template: '\n        <div class="tab-pane" ng-if="$ctrl.tabPanel.selected">\n            <div ng-transclude></div>\n        </div>\n    ',
	    controller: _tabPanel2.default
	};
	
	exports.default = TabPanelComponent;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TabPanelController = function () {
	    function TabPanelController() {
	        _classCallCheck(this, TabPanelController);
	    }
	
	    _createClass(TabPanelController, [{
	        key: "$onInit",
	        value: function $onInit() {
	            this.tabPanel = {
	                title: this.title,
	                selected: false
	            };
	
	            this.tab.addTab(this.tabPanel);
	        }
	    }]);
	
	    return TabPanelController;
	}();
	
	exports.default = TabPanelController;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _hoverable = __webpack_require__(16);
	
	var _hoverable2 = _interopRequireDefault(_hoverable);
	
	var _hoverContent = __webpack_require__(17);
	
	var _hoverContent2 = _interopRequireDefault(_hoverContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HoverableModule = _angular2.default.module('mvac.hoverable', []).directive('hoverable', _hoverable2.default).directive('hoverContent', _hoverContent2.default).name;
	
	exports.default = HoverableModule;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	var HoverableDirective = function HoverableDirective() {
	        return {
	                restrict: 'A',
	                link: function link(scope, element, attrs) {
	                        var direction = attrs.direction || 'bottom';
	                        element.addClass('hoverable hoverable-' + direction);
	
	                        element.on('mouseenter', function () {
	                                element.addClass('hover');
	                        });
	
	                        element.on('mouseleave', function () {
	                                element.removeClass('hover');
	                        });
	
	                        element.on('$destroy', function () {
	                                element.off();
	                        });
	                }
	        };
	};
	
	exports.default = HoverableDirective;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var HoverContentDirective = function HoverContentDirective() {
	    return {
	        restrict: 'A',
	        link: function link(scope, element, attrs) {
	            element.addClass('hover-content');
	        }
	    };
	};
	
	exports.default = HoverContentDirective;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _imgSlider = __webpack_require__(19);
	
	var _imgSlider2 = _interopRequireDefault(_imgSlider);
	
	var _imgSliderPreview = __webpack_require__(21);
	
	var _imgSliderPreview2 = _interopRequireDefault(_imgSliderPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImgSliderModule = _angular2.default.module('mvac.imgslider', [_imgSliderPreview2.default]).component('imgSlider', _imgSlider2.default).name;
	
	exports.default = ImgSliderModule;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _imgSlider = __webpack_require__(20);
	
	var _imgSlider2 = _interopRequireDefault(_imgSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImgSliderComponent = {
	    bindings: {
	        source: '<',
	        sourcePreview: '<',
	        urls: '<',
	        preview: '@',
	        codehotel: '<',
	        session: '@',
	        api: '<'
	    },
	    transclude: true,
	    controller: _imgSlider2.default,
	    template: '\n        <div class="img-slider-container row">\n            <div class="img-slider no-padding" ng-class="($ctrl.isTherePreview) ? \'col-md-8\' : \'col-md-12\'"> \n                <img ng-repeat="slide in $ctrl.slides track by $index" \n                    class="img-slide" \n                    ng-src="{{slide}}" \n                    ng-hide="!$ctrl.isCurrentSlideIndex($index)"\n                    load-error on-load-error="$ctrl.deleteSlide($event)" error-index="$index"\n                    ng-click="$ctrl.agrgar(slide)"\n                    >                \n                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev" ng-click="$ctrl.prevSlide()">\n                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>\n                    <span class="sr-only">Previous</span>\n                    </a>\n                    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next" ng-click="$ctrl.nextSlide()">\n                    <span class="carousel-control-next-icon" aria-hidden="true"></span>\n                    <span class="sr-only">Next</span>\n                    </a>                \n            </div>\n            <input type="hidden" value="{{$ctrl.session}}">\n            <div style="display:none;" id="caja_{{$ctrl.codehotel}}">\n                <a id="bottomGen_{{$ctrl.codehotel}}" style="visibility: hidden;" ng-click="$ctrl.CambiarImg()">GEN</a>\n                <input type="hidden" value="" id="GenImg_{{$ctrl.codehotel}}"> \n                <img id="PreviewDefaul_{{$ctrl.codehotel}}" style="visibility: hidden;" >  \n            </div>\n            <div id="img-preview-slider" ng-class="($ctrl.isTherePreview) ? \'col-md-4 verMas\' : \'hidden\'">\n                <img-slider-preview source="$ctrl.sourcePreview"></img-slider-preview>\n            </div>\n        </div>\n    '
	};
	
	exports.default = ImgSliderComponent;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImgSliderController = function () {
	    function ImgSliderController($interval, HotelFactory, $window) {
	        _classCallCheck(this, ImgSliderController);
	
	        this.currentIndex = 0;
	        this.interval = $interval;
	        this.HotelFactory = HotelFactory;
	        this.intervalId = null;
	        this.imgPreview = null;
	        this.window = $window;
	        this.ulrPath = "https://photos.hotelbeds.com/giata";
	    }
	
	    _createClass(ImgSliderController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.isTherePreview = typeof this.preview === 'undefined' ? false : true;
	        }
	    }, {
	        key: '$onChanges',
	        value: function $onChanges(changes) {
	            var _this = this;
	
	            if (changes.urls) {
	                if (typeof changes.urls.currentValue !== 'undefined') {
	                    this.slides = this.urls.map(function (url) {
	                        return '' + _this.source + url;
	                    });
	                    if (this.intervalId !== null) {
	                        this.setCurrentSlideIndex(0);
	                        this.interval.cancel(this.intervalId);
	                    }
	
	                    if (this.imgPreview !== null) {
	                        this.initImgPreview();
	                    }
	                }
	            }
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            this.interval.cancel(this.intervalId);
	        }
	    }, {
	        key: 'initImgPreview',
	        value: function initImgPreview() {
	            var _this2 = this;
	
	            this.imgPreview.setUrls(this.urls);
	            this.intervalId = this.interval(function () {
	                _this2.nextSlide();
	            }, 10000);
	        }
	    }, {
	        key: 'deleteSlide',
	        value: function deleteSlide(event) {
	
	            this.slides.splice(event.index, 1);
	            if (this.imgPreview !== null) {
	                this.imgPreview.deleteUrl(event.index);
	            }
	        }
	    }, {
	        key: 'isCurrentSlideIndex',
	        value: function isCurrentSlideIndex(index) {
	            return this.currentIndex === index;
	        }
	    }, {
	        key: 'nextSlide',
	        value: function nextSlide() {
	            this.currentIndex = this.currentIndex < this.slides.length - 1 ? ++this.currentIndex : 0;
	        }
	    }, {
	        key: 'prevSlide',
	        value: function prevSlide() {
	            this.currentIndex = this.currentIndex > 0 ? --this.currentIndex : this.slides.length - 1;
	        }
	    }, {
	        key: 'setCurrentSlideIndex',
	        value: function setCurrentSlideIndex(index) {
	
	            this.currentIndex = index;
	        }
	    }, {
	        key: 'ImgDefual',
	        value: function ImgDefual(index) {
	            // this.value2=this.ulrPath+this.urls[index];
	            this.value2 = index;
	
	            if (this.session != 2) {
	                $('#caja_' + this.codehotel).removeClass("ocultar_divmvac");
	                $('#caja_' + this.codehotel).addClass("div_img_gen");
	                $('#GenImg_' + this.codehotel).val(index);
	                $('#PreviewDefaul_' + this.codehotel).attr('src', this.value2);
	                $('#bottomGen_' + this.codehotel).addClass("mvac_img_general");
	                $('#PreviewDefaul_' + this.codehotel).addClass("img_previewDefaul");
	            } else {
	                $('#caja_' + this.codehotel).addClass("ocultar_divmvac");
	            }
	        }
	    }, {
	        key: 'setPreview',
	        value: function setPreview(preview) {
	            this.imgPreview = preview;
	        }
	    }, {
	        key: 'CambiarImg',
	        value: function CambiarImg() {
	
	            var params = {
	                params: {
	                    img: $('#GenImg_' + this.codehotel).val(),
	                    code: this.codehotel,
	                    api: this.api
	                }
	            };
	            this.HotelFactory.imgDefaultGEN(params).then(function (response) {
	
	                if (response.data.estado == true) {
	
	                    swal({
	                        title: "Se cambio la imagen.",
	                        type: "success",
	                        showConfirmButton: true,
	                        allowEscapeKey: false
	                    }, function () {
	                        location.reload();
	                    });
	                } else {
	                    swal({
	                        title: "Lo sentimos, el hotel no se tiene en la base datos.",
	                        imageUrl: "img/signoadmiracion.png",
	                        showConfirmButton: true,
	                        allowEscapeKey: false
	                    }, function () {
	                        // console.log(this.codehotel);
	                        //  $('#caja_'+this.codehotel).addClass("ocultar_divmvac");
	                        // location.reload();
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'agrgar',
	        value: function agrgar(slider) {
	            this.ImgDefual(slider);
	        }
	    }]);
	
	    return ImgSliderController;
	}();
	
	ImgSliderController.$inject = ["$interval", 'HotelFactory', '$window'];
	
	exports.default = ImgSliderController;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _imgSliderPreview = __webpack_require__(22);
	
	var _imgSliderPreview2 = _interopRequireDefault(_imgSliderPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImgSliderPreviewModule = angular.module('mvac.imgsliderpreview', []).component('imgSliderPreview', _imgSliderPreview2.default).name;
	
	exports.default = ImgSliderPreviewModule;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _imgSliderPreview = __webpack_require__(23);
	
	var _imgSliderPreview2 = _interopRequireDefault(_imgSliderPreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImgSliderPreviewComponent = {
	    bindings: {
	        source: '<'
	    },
	    require: {
	        imgSlider: '^^'
	    },
	    controller: _imgSliderPreview2.default,
	    template: '\n        <div class="scrollable img-slider-preview-scrollable" >\n            <img class="imgpreviewclass" ng-repeat="img in $ctrl.imgMini track by $index" \n                    ng-src="{{img}}" \n                    ng-click="$ctrl.changeImageSlider($index)" \n                    class="img-preview"\n                    ng-class="{\'img-preview-active\': $index === $ctrl.imgSlider.currentIndex}"/> \n        </div>\n    '
	};
	
	exports.default = ImgSliderPreviewComponent;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImgSliderPreviewController = function () {
	    function ImgSliderPreviewController() {
	        _classCallCheck(this, ImgSliderPreviewController);
	    }
	
	    _createClass(ImgSliderPreviewController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            this.imgSlider.setPreview(this);
	        }
	    }, {
	        key: 'setUrls',
	        value: function setUrls(urls) {
	            var _this = this;
	
	            this.imgMini = urls.map(function (url) {
	                return '' + _this.source + url;
	            });
	        }
	    }, {
	        key: 'deleteUrl',
	        value: function deleteUrl(indexUrl) {
	            if (typeof this.imgMini !== 'undefined') {
	                this.imgMini.splice(indexUrl, 1);
	            }
	        }
	    }, {
	        key: 'changeImageSlider',
	        value: function changeImageSlider(index) {
	            this.imgSlider.setCurrentSlideIndex(index);
	        }
	    }]);
	
	    return ImgSliderPreviewController;
	}();
	
	exports.default = ImgSliderPreviewController;

/***/ })
/******/ ]);
//# sourceMappingURL=app.bundle.js.map